import MobileMenu from "@scripts/module/mobileMenu.js";

new MobileMenu({
    menu: ".mobile-menu-wrap",
    close: ".mobile-menu-wrap .ui-close",
    open: ".burger",
    overlay: ".ui-overlay",
    closeItems: ".closed",
});
